const normalizeText = (text) => text.replace(/\r\n/g, '\n');

const flushParagraph = (blocks, paragraphLines) => {
  if (!paragraphLines.length) {
    return;
  }

  blocks.push({
    type: 'paragraph',
    text: paragraphLines.join(' '),
  });
  paragraphLines.length = 0;
};

const flushList = (blocks, listItems) => {
  if (!listItems.length) {
    return;
  }

  blocks.push({
    type: 'list',
    items: [...listItems],
  });
  listItems.length = 0;
};

export const parseMarkdown = (source = '') => {
  const blocks = [];
  const lines = normalizeText(source).split('\n');

  const paragraphLines = [];
  const listItems = [];

  let inCodeBlock = false;
  let codeLanguage = '';
  let codeLines = [];

  lines.forEach((rawLine) => {
    const line = rawLine.trimEnd();

    if (inCodeBlock) {
      if (line.startsWith('```')) {
        blocks.push({
          type: 'code',
          language: codeLanguage,
          text: codeLines.join('\n'),
        });
        inCodeBlock = false;
        codeLanguage = '';
        codeLines = [];
      } else {
        codeLines.push(rawLine);
      }
      return;
    }

    if (line.startsWith('```')) {
      flushParagraph(blocks, paragraphLines);
      flushList(blocks, listItems);
      inCodeBlock = true;
      codeLanguage = line.replace('```', '').trim();
      return;
    }

    if (!line) {
      flushParagraph(blocks, paragraphLines);
      flushList(blocks, listItems);
      return;
    }

    const headingMatch = line.match(/^(#{1,3})\s+(.+)$/);
    if (headingMatch) {
      flushParagraph(blocks, paragraphLines);
      flushList(blocks, listItems);
      blocks.push({
        type: 'heading',
        level: headingMatch[1].length,
        text: headingMatch[2].trim(),
      });
      return;
    }

    const listMatch = line.match(/^-\s+(.+)$/);
    if (listMatch) {
      flushParagraph(blocks, paragraphLines);
      listItems.push(listMatch[1].trim());
      return;
    }

    flushList(blocks, listItems);
    paragraphLines.push(line.trim());
  });

  flushParagraph(blocks, paragraphLines);
  flushList(blocks, listItems);

  if (inCodeBlock) {
    blocks.push({
      type: 'code',
      language: codeLanguage,
      text: codeLines.join('\n'),
    });
  }

  return blocks;
};

